var _path, _path2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3903 4.31731C10.8205 2.5609 13.3409 2.5609 13.7711 4.31731C14.049 5.45193 15.3606 5.99038 16.3666 5.38285C17.924 4.44239 19.7061 6.2087 18.7573 7.75218C18.1442 8.74925 18.6875 10.0492 19.8323 10.3246C21.6045 10.751 21.6045 13.249 19.8323 13.6754C18.6875 13.9508 18.1442 15.2507 18.7573 16.2478C19.7061 17.7913 17.924 19.5576 16.3666 18.6172C15.3606 18.0096 14.049 18.5481 13.7711 19.6827C13.3409 21.4391 10.8205 21.4391 10.3903 19.6827C10.1124 18.5481 8.80082 18.0096 7.79481 18.6172C6.23747 19.5576 4.45532 17.7913 5.40422 16.2478C6.0172 15.2507 5.47392 13.9508 4.32912 13.6754C2.55696 13.249 2.55696 10.751 4.32912 10.3246C5.47392 10.0492 6.01719 8.74926 5.40422 7.75218C4.45532 6.2087 6.23747 4.44239 7.79481 5.38285C8.80082 5.99037 10.1124 5.45193 10.3903 4.31731Z",
    stroke: "#A52EBE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1075 12C15.1075 13.6569 13.7524 15 12.0806 15C10.4089 15 9.05371 13.6569 9.05371 12C9.05371 10.3431 10.4089 9 12.0806 9C13.7524 9 15.1075 10.3431 15.1075 12Z",
    stroke: "#A52EBE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.5d33618b.svg";
export { ForwardRef as ReactComponent };